import { render, staticRenderFns } from "./AnnulerRole.vue?vue&type=template&id=5c580d44&"
import script from "./AnnulerRole.vue?vue&type=script&lang=js&"
export * from "./AnnulerRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports